import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=5cddf228&scoped=true&"
import script from "./Sort.vue?vue&type=script&lang=js&"
export * from "./Sort.vue?vue&type=script&lang=js&"
import style0 from "./Sort.vue?vue&type=style&index=0&id=5cddf228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!//node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cddf228",
  null
  
)

export default component.exports